import { fetchPageData } from "../../fetchPageData"
import Cookies from 'js-cookie';
import { getStorageItem } from "../../helpers/storageManager";
import { subscriptionData } from '../../MFEs/Monetization-Sdk/src/Api'

export const fetchAuthenticationV2Module = async() => {
    window.countryCode = window.page_data?.countryCode	
   const authData = getStorageItem('AuthenticationStore')	
   const userStateToken = Cookies.get("userStateToken") || authData?.user?.userState
   let baseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl		
   let endpoint = window?.cachedAPI || `${baseUrl}/graphql`
   let parsedCountryCode = window.page_data?.countryCode || "IN" //(countryCode && countryCode.country && (countryCode.country).toLowerCase()) || ""
   let offset = 0
   let variables = {
     site: (window?.app_data?.site?.siteInternalName) || null,
     device: "WEB",
     includeContent: true,
     moduleLimit: 4,
     moduleOffset: offset,
     languageCode: window?.app_data?.appcmsMain?.languages?.default?.code || "en",
     countryCode: parsedCountryCode,
     userState: authData ? userStateToken : window.btoa(JSON.stringify({ "state": ["loggedOut"] })),
     modules: [],
     platform : 'web_browser',
     path: '/authentication02'
   }
    const data = fetchPageData(variables, endpoint)
    return data
}

export const getUserPlans = async (user, isSubscribed, isTveLoggedIn) => {
  let userPlanIds = [];

  try {
    let subscription = user?.subscription;
    if (!subscription) {
      subscription = await subscriptionData();
    }

    if (subscription) {
      if (isSubscribed && subscription?.subscriptionInfo?.planId) {
        userPlanIds.push(subscription.subscriptionInfo.planId);
      }

      if (isTveLoggedIn) {
        const tveSubscriptionsArr = subscription?.tveSubscriptions?.map(plan => plan?.planId).filter(Boolean) || [];
        userPlanIds.push(...tveSubscriptionsArr);
      }
    }
  } catch (e) {
    logger(e, "error");
  }

  return userPlanIds;
}

export const handleNavigationPlanRedirect = async (navigation, userPlanIds = []) => {
  const navigationPlansArr = navigation?.navigationPlans || [];

  let planGroupList = [];
  try {
    const storedPlanGroupList = localStorage.getItem("planGroupList");
    planGroupList = storedPlanGroupList ? JSON.parse(storedPlanGroupList) : [];
  } catch (error) {
    console.error("Invalid planGroupList JSON in localStorage", error);
  }

  const navigationPlansIdsArr = navigationPlansArr.map((navigationPlan) =>
    (navigationPlan?.planType === "plangroup") ? (planGroupList[navigationPlan?.planID] || []) : (navigationPlan?.planID)
  );
  const navigationPlansIds = navigationPlansIdsArr.flat(Infinity);
  const matchedPlanIds = navigationPlansIds.filter((id) => userPlanIds.includes(id));
  
  // For redirecting first match navigation plan
  if (matchedPlanIds.length > 0 && !sessionStorage.getItem('redirectUrl')) { 
    sessionStorage.setItem('redirectUrl', navigation?.url);
  }

  return matchedPlanIds.length > 0;
};


export const redirectPage = () => {
  const getPageUrl = window.location.pathname
  const redirectUrl = sessionStorage.getItem('redirectUrl')
  const alreadyRedirected = sessionStorage.getItem('alreadyRedirected')
  
  if(getPageUrl === redirectUrl) {
    sessionStorage.setItem('alreadyRedirected', 'true')
    return
  }

  if(!alreadyRedirected && redirectUrl && (getPageUrl !== redirectUrl)) {
    sessionStorage.setItem('alreadyRedirected', 'true')
    window.location.href = redirectUrl
  }
}